function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import useUser from './useUser';
import { useGetUserProjectsQuery } from '../../redux/rtk';
import { jobHasPointCloud } from '../../utilities/job';
var useHasProjectWithPointcloud = function() {
    var includeDemo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var _useUser = useUser(), isAdmin = _useUser.isAdmin, isSuccess = _useUser.isSuccess;
    var result = useGetUserProjectsQuery({
        isAdmin: isAdmin,
        includeDemo: includeDemo
    }, {
        skip: !isSuccess,
        selectFromResult: function(res) {
            var _res_data;
            var obj = (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.projects;
            if (!obj) return _object_spread_props(_object_spread({}, res), {
                data: false
            });
            var hasPointCloud = Object.values(obj).some(function(project) {
                return jobHasPointCloud(project);
            });
            return _object_spread_props(_object_spread({}, res), {
                data: hasPointCloud
            });
        }
    });
    return {
        hasPointCloud: result.data,
        isLoading: result.isLoading || !isSuccess,
        status: result.status
    };
};
export default useHasProjectWithPointcloud;
